/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ItemWrap } from '@/components/layouts/ItemWrap';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Stack, useTheme } from '@mui/material';
import { FC } from 'react';

export const CustomTemplate: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		dimensions: { contentSpacing },
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack
				component="main"
				gap={contentSpacing}
				alignItems="center"
				sx={layoutMainSX(layout.slots.first?.length || 0)}
			>
				<LayoutSlot slot={layout.slots.first} ItemWrap={ItemWrap} />
				<Container component="section" maxWidth="xl">
					<Grid container spacing={contentSpacing}>
						<Grid item component="section" xs={4}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.second} />
							</Stack>
						</Grid>
						<Grid item component="section" xs={4}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.third} />
							</Stack>
						</Grid>
						<Grid item component="section" xs={4}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.fourth} />
							</Stack>
						</Grid>
					</Grid>
				</Container>
				<LayoutSlot slot={layout.slots.fifth} ItemWrap={ItemWrap} />
				<Container component="section" maxWidth="xl">
					<Grid container spacing={contentSpacing}>
						<Grid item component="section" xs={4}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.sixth} />
							</Stack>
						</Grid>
						<Grid item component="section" xs={8}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.seventh} />
							</Stack>
						</Grid>
					</Grid>
				</Container>
				<LayoutSlot slot={layout.slots.eighth} ItemWrap={ItemWrap} />
				<Container component="section" maxWidth="xl">
					<Grid container spacing={contentSpacing}>
						<Grid item component="section" xs={8}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.ninth} />
							</Stack>
						</Grid>
						<Grid item component="section" xs={4}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.tenth} />
							</Stack>
						</Grid>
					</Grid>
				</Container>
				<LayoutSlot slot={layout.slots.eleventh} ItemWrap={ItemWrap} />
				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</>
	) : null;
};
